export default {
  default: function _default(h, conf, key) {
    return conf.__slot__[key];
  }
};